const menulist = [
  {
      "path":"/home",
      "remark":"layout",
      "name":"首页",
      "redirect":"/home/index",
      "hidden":false,
      "meta":{
          "title":"首页",
          "icon":"fa-home"
      },
      "children":[
          {
              "path":"index",
              "remark":"home",
              "name":"主页",
              "hidden":false,
              "meta":{
                  "title":"主页",
                  "icon":""
              }
          },
          {
              "path":"userinfo",
              "name":"基本信息",
              "remark":"userinfo",
              "hidden":true,
              "meta":{
                  "title":"基本信息"
              }
          },
          {
              "path":"changepassword",
              "name":"密码修改",
              "remark":"changepassword",
              "hidden":true,
              "meta":{
                  "title":"密码修改",
                  "icon":"svg-sqlb"
              }
          }
      ]
  },
  {
      "path":"/systemsetting",
      "remark":"layout",
      "name":"系统设置",
      "redirect":"/systemsetting/system",
      "hidden":false,
      "meta":{
          "title":"系统设置",
          "icon":"fa-cogs"
      },
      "children":[
          {
              "path":"system",
              "remark":"systemsetting",
              "name":"应用管理",
              "hidden":false,
              "meta":{
                  "title":"应用管理",
                  "icon":"fa-th"
              }
          },
          {
              "path":"right",
              "remark":"rightsetting",
              "name":"权限管理",
              "hidden":false,
              "meta":{
                  "title":"权限管理",
                  "icon":"fa-unlock"
              }
          },
          {
              "path":"role",
              "remark":"rolesetting",
              "name":"角色管理",
              "hidden":false,
              "meta":{
                  "title":"角色管理",
                  "icon":"fa-street-view"
              }
          },
          {
              "path":"menu",
              "remark":"menusetting",
              "name":"菜单管理",
              "hidden":false,
              "meta":{
                  "title":"菜单管理",
                  "icon":"fa-tasks"
              }
          },
          {
              "path":"sysapi",
              "remark":"sysapisetting",
              "name":"webapi管理",
              "hidden":false,
              "meta":{
                  "title":"webapi管理",
                  "icon":"fa-cubes"
              }
          }
      ]
  },
  {
      "path":"/hospitalsetting",
      "remark":"layout",
      "name":" 医院设置",
      "redirect":"/hospitalsetting/hospital",
      "hidden":false,
      "meta":{
          "title":" 医院设置",
          "icon":"fa-medkit"
      },
      "children":[
          {
              "path":"hospital",
              "remark":"hospitalsetting",
              "name":"医院管理",
              "hidden":false,
              "meta":{
                  "title":"医院管理",
                  "icon":"fa-hospital-o"
              }
          },
          {
              "path":"department",
              "remark":"departmentsetting",
              "name":"科室管理",
              "hidden":false,
              "meta":{
                  "title":"科室管理",
                  "icon":"fa-calendar-plus-o"
              }
          },
          {
              "path":"group",
              "remark":"groupsetting",
              "name":"小组管理",
              "hidden":false,
              "meta":{
                  "title":"小组管理",
                  "icon":"fa-users"
              }
          },
          {
              "path":"user",
              "remark":"usersetting",
              "name":"用户管理",
              "hidden":false,
              "meta":{
                  "title":"用户管理",
                  "icon":"fa-user-circle"
              }
          },
          {
              "path":"patientlsetting",
              "remark":"patientsetting",
              "name":"患者列表",
              "hidden":false,
              "meta":{
                  "title":"患者列表",
                  "icon":"svg-hzlb"
              }
          }
      ]
  },
  {
      "path":"/templatesetting",
      "remark":"layout",
      "name":"模板设置",
      "redirect":"/templatesetting/qcfactorandpf",
      "hidden":false,
      "meta":{
          "title":"模板设置",
          "icon":"fa-table"
      },
      "children":[
          {
              "path":"qcfactorandpf",
              "remark":"qcfactorandpfsetting",
              "name":"质控因子评分管理",
              "hidden":false,
              "meta":{
                  "title":"质控因子评分管理",
                  "icon":"svg-zkyzpfgl"
              }
          },
          {
              "path":"dictionary",
              "remark":"dictionarysetting",
              "name":"数据字典",
              "hidden":false,
              "meta":{
                  "title":"数据字典",
                  "icon":"svg-sjzd"
              }
          },
          {
              "path":"dictionarysystem",
              "remark":"dictionarycomp",
              "name":"系统配置",
              "hidden":false,
              "meta":{
                  "title":"系统配置",
                  "icon":"svg-sjzd"
              }
          },
          {
              "path":"remotetemplate",
              "remark":"templatesetting",
              "name":"模板管理",
              "hidden":false,
              "meta":{
                  "title":"模板管理",
                  "icon":"svg-mbgl"
              }
          }
      ]
  }
]

export default menulist



// WEBPACK FOOTER //
// ./src/data/menulistjson.js